import { useTranslation } from "react-i18next";

import OverrideReportPageCSVQuery from "./OverrideReportPageCSVQuery";

import { ContentContainer } from "pstat-anywhere/components/pages";
import { AdvancedReportPage } from "pstat-anywhere/components/pages/reports";
import { withLabelContext } from "pstat-anywhere/context_providers/LabelContext";


function OverrideReportPage({
  match,
  router,
  location,
  labels,
  overrideReport
}) {
  const { t } = useTranslation();

  const actions = overrideReport?.actions;
  const transformedData = actions
    ? {
        ...actions,
        edges: actions.edges?.map(edge => ({
          ...edge,
          node: {
            ...edge?.node,
            pk: edge?.node?.document?.pk
          }
        }))
      }
    : actions;

  return (
    <ContentContainer>
      <AdvancedReportPage
        headerText={t("administration.reports.overrideReport", {
          defaultValue: "Override Report"
        })}
        route={match}
        router={router}
        location={location}
        labels={labels}
        data={transformedData}
        tableType={"override_report"}
        noContentMessage={t("administration.reports.overrideReport.noContent")}
        showPagination={true}
        showActionButtonPanel={false}
        showTabsPanel={false}
        csvQueryName="overrideReportCsv"
        csvQueryArgs={{}}
        CSVQuery={OverrideReportPageCSVQuery}
      />
    </ContentContainer>
  );
}

export default withLabelContext(OverrideReportPage);
